const unwrap = (response) => {
    if (response && response.data && Object.prototype.hasOwnProperty.call(response.data, 'data')) {
        return response.data.data
    }

    return response && response.data ? response.data : response
}

const post = (url, payload) => axios.post(url, payload).then(unwrap)
const importUrl = (url, uuid) => String(url || '').replace('__IMPORT__', uuid)

export default {

    loadCalendar(config, payload) {
        return post(config.api.calendar || config.api.load, payload)
    },

    validate(config, payload) {
        return post(config.api.validate, payload)
    },

    save(config, payload) {
        return post(config.api.save || config.api.store, payload)
    },

    delete(config, payload) {
        return post(config.api.delete, payload)
    },

    availability(config, payload) {
        return post(config.api.availability || config.api.availabilityCheck, payload)
    },

    availabilityBulk(config, payload) {
        return post(config.api.availabilityBulk, payload)
    },

    requestAvailabilityConfirmation(config, payload) {
        const url = config.api.availabilityRequestConfirmation || '/admin/calendarv2/api/availability/request-confirmation'
        return post(url, payload)
    },

    stats(config, payload) {
        return post(config.api.stats, payload)
    },

    diagnostics(config, payload) {
        const url = (config.api && config.api.diagnostics)
            ? config.api.diagnostics
            : '/admin/calendarv2/api/diagnostics'

        return post(url, payload)
    },

    dayPastePreview(config, payload) {
        return post(config.api.dayPastePreview, payload)
    },

    dayPasteApply(config, payload) {
        return post(config.api.dayPasteApply, payload)
    },

    updateStaff(config, payload) {
        return post(config.api.updateStaff, payload)
    },

    updateCourseHours(config, payload) {
        return post(config.api.updateCourseHours, payload)
    },

    recurringPreview(config, payload) {
        return post(config.api.recurringPreview, payload)
    },

    recurringApply(config, payload) {
        return post(config.api.recurringApply, payload)
    },

    teacherSuggest(config, payload) {
        return post(config.api.teacherSuggest, payload)
    },

    orarioWebLatest(config, courseId) {
        return axios.get(config.api.orarioWebLatest, {params: {corso_id: courseId}}).then(unwrap)
    },

    orarioWebAnalyse(config, payload) {
        return axios.post(config.api.orarioWebAnalyse, payload, {
            headers: {'Content-Type': 'multipart/form-data'}
        }).then(unwrap)
    },

    orarioWebUpdate(config, uuid, payload) {
        return axios.patch(importUrl(config.api.orarioWebUpdate, uuid), payload).then(unwrap)
    },

    orarioWebPreview(config, uuid) {
        return post(importUrl(config.api.orarioWebPreview, uuid), {})
    },

    orarioWebApply(config, uuid, payload) {
        return post(importUrl(config.api.orarioWebApply, uuid), payload)
    },

    orarioWebDiscard(config, uuid) {
        return axios.delete(importUrl(config.api.orarioWebDiscard, uuid)).then(unwrap)
    }
}
